import { isLoggedInUser, signin } from '../../common/auth';
import { appShadowRoot } from '../../common/elements';
import { FirstRoute, Welcomed, ScrollTo } from '../../common/keys';
import { log } from '../../common/log';
import { o } from '../../common/observable';
import { lang, render } from '../../common/page';
import { profile } from '../../common/profile';
import { r } from '../../common/router';
import { skills as skillsUrl } from '../../common/urls';
import { article } from './article';
import { queryString } from './querystring';
import { recommend } from './recommend';
import { first, newAccount } from './router';

export async function orchestrate() {
  const authenticated = await isLoggedInUser();
  const url = new URL(location.href);
  let done = false;
  let trigger = false;

  if (authenticated && newAccount) {
    window.location.href = `/${lang}/profile`;
  }

  if (url.searchParams.has('launch')) {
    const target = url.searchParams.get('launch');

    trigger = true;

    if (target.includes('-')) {
      if (authenticated) {
        queryString('launch');
      }
    } else {
      queryString('launch');
      article(target);
    }
  }

  if (url.searchParams.has('recommended')) {
    if (authenticated) {
      const target = url.searchParams.get('recommended');

      queryString('recommended');
      done = trigger = true;
      await recommend(target, true, true, true);
    } else {
      signin();
    }
  }

  /* if (url.searchParams.has('recommended')) {
    // navigate to /<lang>/playlists, keep all parameters except lang UGP-11279
    url.pathname = `/${lang}/playlists`;
    // remove hash
    url.hash = '';
    // remove lang parameter - it's in the pathname
    url.searchParams.delete('lang');
    url.searchParams.delete('recommended');
    // needed to show redirection alert on playlist page
    url.searchParams.set('redirected', '');
    window.location.href = url.href;
  } */

  if (authenticated && done === false) {
    const fr = sessionStorage.getItem(FirstRoute) || '';

    if (fr.length > 0) {
      trigger = true;
      log(`Redirecting to previous route: #${fr}`);
      location.hash = fr;
    }
  }

  if (authenticated && trigger === false && done === false) {
    const data = await profile();
    const nnow = new Date();
    const then = new Date(data.timestamp || new Date('2018/01/01'));
    const lfirst = location.hash.substring(1) === first;

    if (
      lfirst &&
      nnow.getFullYear() === then.getFullYear() &&
      nnow.getMonth() === then.getMonth() &&
      nnow.getDate() === then.getDate()
    ) {
      if (Welcomed in localStorage === false) {
        log('Welcoming');
        trigger = true;
        localStorage.setItem(Welcomed, 'true');
        location.hash = 'dashboard/welcome';
      } else {
        log('Skipping welcome');
      }
    }
  }

  if (url.searchParams.has(ScrollTo)) {
    const id = url.searchParams.get(ScrollTo);
  } else {
    log(`Removing event handler for ${ScrollTo}`);
    o.off(ScrollTo);
  }

  sessionStorage.removeItem(FirstRoute);
  log('Enabling router (active)');

  if (location.hash.startsWith('#recommended')) {
    r.start = location.hash.replace('#', '');
  }

  r.active = true;
  r.process();

  if (url.searchParams.has('scrollto')) {
    const target = url.searchParams.get('scrollto');

    o.once('scrollto', () => {
      log(`scrollto #${target} event triggered.`);

      if (appShadowRoot.querySelector(`#${target}`) !== null) {
        appShadowRoot.querySelector(`#${target}`).scrollIntoView(true);
        log(`Scrolled to ${target}`);
      } else {
        log(`Scroll target "#${target}" doesn't exist`);
      }

      queryString('scrollto');
    });
  }
}
